import styled from "styled-components";

export const StyledPopoverBody = styled.div`
    width: 558px;
    height: 515px;
    background-color: white;
    box-shadow: 0px 11px 14px 7px rgba(0, 0, 0, 0.11);
`;
